import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useHrAccess } from "../../hooks/useHrAccess";

const legacyMap: Record<string, string> = {
  "": "/directory",
  "/": "/directory",
  "/overview": "/directory",
  "/people": "/directory",
  "/punch": "/my-attendance",
  "/me": "/my-attendance",
  "/attendance": "/my-attendance",
  "/announcements": "/directory",
  "/documents": "/directory",
};

const HrIndexRedirect = () => {
  const { pathname } = useLocation();
  const rest = pathname.replace(/^\/dashboard\/hr/, "");
  const suffix = legacyMap[rest] ?? (rest || "/people");
  return <Navigate to={`/dashboard/employee${suffix}`} replace />;
};

export function HrAdminOnly() {
  const { isHrAdmin, canEditNotebook } = useHrAccess();
  if (isHrAdmin) return <Outlet />;
  if (canEditNotebook) {
    return <Navigate to="/dashboard/employee/my-attendance" replace />;
  }
  return <Navigate to="/dashboard/employee/overview" replace />;
}

export default HrIndexRedirect;
